/**
 * @generated SignedSource<<b171247c03452313a44a00cebcc4b6f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RenameCustomerAccountInput = {
  customerName: string;
  id: string;
};
export type CustomerAccountViewRenameCustomerMutation$variables = {
  input: RenameCustomerAccountInput;
};
export type CustomerAccountViewRenameCustomerMutation$data = {
  readonly renameCustomerAccount: {
    readonly customerName: string;
    readonly id: string;
  };
};
export type CustomerAccountViewRenameCustomerMutation = {
  response: CustomerAccountViewRenameCustomerMutation$data;
  variables: CustomerAccountViewRenameCustomerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CustomerAccount",
    "kind": "LinkedField",
    "name": "renameCustomerAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customerName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerAccountViewRenameCustomerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerAccountViewRenameCustomerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "75a4085b947ef7ad48c83da4fcd05b68",
    "id": null,
    "metadata": {},
    "name": "CustomerAccountViewRenameCustomerMutation",
    "operationKind": "mutation",
    "text": "mutation CustomerAccountViewRenameCustomerMutation(\n  $input: RenameCustomerAccountInput!\n) {\n  renameCustomerAccount(input: $input) {\n    id\n    customerName\n  }\n}\n"
  }
};
})();

(node as any).hash = "b37c33cad0f444e464126a16b84085d4";

export default node;
